import { defineCustomElement } from '@tyler-components-web/core';
import { SkeletonComponent } from './skeleton';
export * from './skeleton-constants';
export * from './skeleton';
export function defineSkeletonComponent() {
    defineCustomElement(SkeletonComponent);
}
